import type { StateCreator } from 'zustand';

/**
 * Types de filtres pour les différentes vues
 */
export interface ProjectFilters {
  status?: string;
  client_id?: string;
  search?: string;
  sortBy?: 'name' | 'start_date' | 'end_date' | 'budget';
  sortOrder?: 'asc' | 'desc';
}

export interface InvoiceFilters {
  status?: string;
  provider_id?: string;
  project_id?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
}

export interface UserFilters {
  role?: string;
  company_id?: string;
  search?: string;
}

/**
 * Filters Slice - Gestion des filtres globaux
 */
export interface FiltersSlice {
  // Project filters
  projectFilters: ProjectFilters;
  setProjectFilters: (filters: Partial<ProjectFilters>) => void;
  resetProjectFilters: () => void;

  // Invoice filters
  invoiceFilters: InvoiceFilters;
  setInvoiceFilters: (filters: Partial<InvoiceFilters>) => void;
  resetInvoiceFilters: () => void;

  // User filters
  userFilters: UserFilters;
  setUserFilters: (filters: Partial<UserFilters>) => void;
  resetUserFilters: () => void;

  // Reset all filters
  resetAllFilters: () => void;
}

const DEFAULT_PROJECT_FILTERS: ProjectFilters = {
  sortBy: 'start_date',
  sortOrder: 'desc',
};

const DEFAULT_INVOICE_FILTERS: InvoiceFilters = {};

const DEFAULT_USER_FILTERS: UserFilters = {};

export const createFiltersSlice: StateCreator<FiltersSlice> = (set) => ({
  // Project filters
  projectFilters: DEFAULT_PROJECT_FILTERS,

  setProjectFilters: (filters) =>
    set((state) => ({
      projectFilters: { ...state.projectFilters, ...filters },
    })),

  resetProjectFilters: () => set({ projectFilters: DEFAULT_PROJECT_FILTERS }),

  // Invoice filters
  invoiceFilters: DEFAULT_INVOICE_FILTERS,

  setInvoiceFilters: (filters) =>
    set((state) => ({
      invoiceFilters: { ...state.invoiceFilters, ...filters },
    })),

  resetInvoiceFilters: () => set({ invoiceFilters: DEFAULT_INVOICE_FILTERS }),

  // User filters
  userFilters: DEFAULT_USER_FILTERS,

  setUserFilters: (filters) =>
    set((state) => ({
      userFilters: { ...state.userFilters, ...filters },
    })),

  resetUserFilters: () => set({ userFilters: DEFAULT_USER_FILTERS }),

  // Reset all
  resetAllFilters: () =>
    set({
      projectFilters: DEFAULT_PROJECT_FILTERS,
      invoiceFilters: DEFAULT_INVOICE_FILTERS,
      userFilters: DEFAULT_USER_FILTERS,
    }),
});
